// Function to encrypt JSON using AES-GCM (Web Crypto API)
const encryptJSON = async (json, secretKey) => {
  const cryptoObj = window.crypto || window.msCrypto;
  if (!cryptoObj || !cryptoObj.subtle) {
    throw new Error(
      'Web Crypto API is not supported in this browser context (must be HTTPS or localhost).'
    );
  }

  const encoder = new TextEncoder();
  const jsonString = JSON.stringify(json);

  // 1. Hash the secret key using SHA-256 to derive a 32-byte key
  const secretKeyData = encoder.encode(secretKey);
  const keyHash = await cryptoObj.subtle.digest('SHA-256', secretKeyData);

  // 2. Import key
  const cryptoKey = await cryptoObj.subtle.importKey('raw', keyHash, { name: 'AES-GCM' }, false, [
    'encrypt',
  ]);

  // 3. Generate a random 12-byte IV
  const iv = cryptoObj.getRandomValues(new Uint8Array(12));

  // 4. Encrypt payload
  const plaintextData = encoder.encode(jsonString);
  const encryptedBuffer = await cryptoObj.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv: iv,
    },
    cryptoKey,
    plaintextData
  );

  // 5. Convert to hex strings
  const encryptedBytes = new Uint8Array(encryptedBuffer);

  // Web Crypto API appends the 16-byte auth tag at the end of the ciphertext
  const ciphertextBytes = encryptedBytes.slice(0, encryptedBytes.length - 16);
  const tagBytes = encryptedBytes.slice(encryptedBytes.length - 16);

  // Helper to convert ArrayBuffer/Uint8Array to hex string
  const bufToHex = (buf) =>
    Array.from(new Uint8Array(buf))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');

  const ivHex = bufToHex(iv);
  const tagHex = bufToHex(tagBytes);
  const ciphertextHex = bufToHex(ciphertextBytes);

  // Combine into iv:tag:ciphertext
  return `${ivHex}:${tagHex}:${ciphertextHex}`;
};

export default encryptJSON;
